export class Club {
    public ClubId:string;

    public Name:string;

    public Description:string;

    public RCIClubId:number;

    public Type:string;

    public SubType:string;

    public Country:string;

    public DistrictId:number;

    public MemberCount:number;

    public MemberCountAsOfDate:Date;

    public HonoraryMemberCount:number;

    public InteractClubs:number;

    public RotoractClubs:number;

    public AnnualFund:number;

    public PolioPlusFund:number;

    public MajorGifts:number;

    public PeopleInBequestSociety:number;

    public Benefactors:number;

    public ParentOrgNodeId:string;

    public OrgNodeId:string;
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/ng-router-loader?{"loader":"async-system","genDir":"compiled","aot":false}!./src/app/entities/club.ts